import {Component, EventEmitter,ViewEncapsulation,Input,Output  } from '@angular/core';

@Component({
  selector: 'ngbd-modal-customclassgroup',
  templateUrl: './modal-customclassgroup.html'
})
export class NgbdModalCustomclassgroup {
	@Input() activeFieldGroupType;
	@Input() fieldTabArray;
	@Output() AddMoreOptionsFInsideTab = new EventEmitter();
	@Output() AddOptionsFieldInsideGroups = new EventEmitter();
	@Output() close_group_field = new EventEmitter();
  constructor() {
	
  }
  
  AddMoreOptionsFInside(h){
	this.AddMoreOptionsFInsideTab.emit(h);
  }
  AddOptionsFieldInsideGroup(){
	this.AddOptionsFieldInsideGroups.emit();
  } 
  close_pop(){
	this.close_group_field.emit();
  }
}



// WEBPACK FOOTER //
// ./src/app/system_setting/DFB/template/create/modal-customclassgroup.ts